export const PATHWAY_TYPES =  {
    'pathway': 1,
    'milestone': 2,
    'requirement': 3,
};
